if (!customElements.get("sticky-atc")) {
  customElements.define(
    "sticky-atc",
    class StickyAtc extends HTMLElement {
      constructor() {
        super();

        this.mainProdForm = document.querySelector("product-form.main-prod-form");
        this.copyOfMainProdForm = document
          .querySelector("product-form.main-prod-form")
          .cloneNode(true);
        this.copyOfMainProdForm.classList.add("cloneNode");
        this.copyOfMainProdForm.querySelectorAll("input[type=radio]").forEach((i) => {
          i.id = i.id + "-clone";
        });
        this.copyOfMainProdForm.querySelectorAll("label").forEach((l) => {
          l.htmlFor = l.htmlFor + "-clone";
        });
        this.mainFormContainer = document.querySelector(".product-form__container");

        if (this.mainProdForm) window.addEventListener("scroll", this.scrollStickyATC.bind(this));
      }

      scrollStickyATC() {
        const headerBottom = document
          .querySelector("#shopify-section-header")
          .getBoundingClientRect().bottom;
        const productFormBottom = this.mainFormContainer.getBoundingClientRect().bottom;

        var formHeight, pickerHeight, marginHeight, stickyHeight;
        if (!this.classList.contains("stickyactive")) {
          formHeight = this.mainProdForm.offsetHeight;

          const formStyle = window.getComputedStyle(document.querySelector("product-form"));
          marginHeight = parseFloat(formStyle.marginTop) + parseFloat(formStyle.marginBottom);
        } else {
          stickyHeight = this.offsetHeight;
        }

        if (productFormBottom <= headerBottom && !this.classList.contains("stickyactive")) {
          this.getFormContents(formHeight, marginHeight);
          this.classList.add("stickyactive");
        } else if (productFormBottom > headerBottom && this.classList.contains("stickyactive")) {
          this.returnFormContents(stickyHeight);
          this.classList.remove("stickyactive");
        }
      }

      async getFormContents(formHeight, marginHeight = 0) {
        if (formHeight && !isNaN(formHeight)) {
          this.mainFormContainer.style.height = `${formHeight + marginHeight}px`;
        }
        this.style.height = "auto";

        const oosCanadaProductIds = [];
        const oosUkProductIds = [];
        const oosUsaProductIds = [];

        for (const key in disableStickyATC) {
          if (disableStickyATC[key] === "no_CAN") {
            oosCanadaProductIds.push(key);
          } else if (disableStickyATC[key] === "no_UK") {
            oosUkProductIds.push(key);
          } else {
            oosUsaProductIds.push(key);
          }
        }

        if (oosCanadaProductIds.length > 0 && window.location.href.includes("/en-ca/")) {
          oosCanadaProductIds.forEach((productId) => {
            if (this.copyOfMainProdForm.querySelector(`form[data-productid="${productId}"]`)) {
              this.copyOfMainProdForm
                .querySelector(".product-form__buttons button[type='submit']")
                .setAttribute("disabled", true);

              this.copyOfMainProdForm
                .querySelector("variant-selects select")
                ?.setAttribute("disabled", true);
              this.copyOfMainProdForm.querySelector(
                ".product-form__buttons button[type='submit']"
              ).innerHTML = "SOLD OUT";
            }
          });
        }

        if (oosUkProductIds.length > 0 && window.location.href.includes("/en-gb/")) {
          oosUkProductIds.forEach((productId) => {
            if (this.copyOfMainProdForm.querySelector(`form[data-productid="${productId}"]`)) {
              this.copyOfMainProdForm
                .querySelector(".product-form__buttons button[type='submit']")
                .setAttribute("disabled", true);

              this.copyOfMainProdForm
                .querySelector("variant-selects select")
                ?.setAttribute("disabled", true);
              this.copyOfMainProdForm.querySelector(
                ".product-form__buttons button[type='submit']"
              ).innerHTML = "SOLD OUT";
            }
          });
        }

        if (
          oosUsaProductIds.length > 0 &&
          !window.location.href.includes("/en-ca/") &&
          !window.location.href.includes("/en-gb/")
        ) {
          oosUsaProductIds.forEach((productId) => {
            if (this.copyOfMainProdForm.querySelector(`form[data-productid="${productId}"]`)) {
              this.copyOfMainProdForm
                .querySelector(".product-form__buttons button[type='submit']")
                .setAttribute("disabled", true);
              this.copyOfMainProdForm.querySelector(
                ".product-form__buttons button[type='submit']"
              ).innerHTML = "SOLD OUT";
            }
          });
        }

        this.getDetailsStickyAtc();

        this.appendChild(this.copyOfMainProdForm);
      }

      disableStickyAtcByRegionCode = (region_code) => {
        const atcButton = this.copyOfMainProdForm.querySelector("button.custom-atc");
        const selectElement = this.copyOfMainProdForm.querySelector("select");
        atcButton.setAttribute("disabled", true);
        selectElement?.setAttribute("disabled", true);
        atcButton.innerHTML = `SOLD OUT`;
      };

      getDetailsStickyAtc = async () => {
        if (oosStates.length > 0) {
          try {
            const response = await fetch("http://ipwhois.pro/?key=yvRfcyIBk5fJAAei");
            const data = await response.json();

            if (data.success) {
              if (data.country_code === "US") {
                if (oosStates.includes("no_CA")) {
                  switch (data.region_code) {
                    case "AZ":
                    case "CA":
                    case "ID":
                    case "MT":
                    case "NV":
                    case "OR":
                    case "UT":
                    case "WA":
                    case "WY":
                    case "CO":
                      this.disableStickyAtcByRegionCode(data.region_code);
                      break;
                    default:
                  }
                }
                if (oosStates.includes("no_TX")) {
                  switch (data.region_code) {
                    case "KS":
                    case "NM":
                    case "AR":
                    case "LA":
                    case "OK":
                    case "TX":
                      this.disableStickyAtcByRegionCode(data.region_code);
                      break;
                    default:
                  }
                }
                if (oosStates.includes("no_IL")) {
                  switch (data.region_code) {
                    case "ND":
                    case "SD":
                    case "NE":
                    case "IL":
                    case "WI":
                    case "MN":
                    case "IA":
                    case "MO":
                    case "IN":
                    case "AK":
                    case "HI":
                    case "PR":
                    case "DC":
                      this.disableStickyAtcByRegionCode(data.region_code);
                      break;
                    default:
                  }
                }
                if (oosStates.includes("no_OH")) {
                  switch (data.region_code) {
                    case "WV":
                    case "OH":
                    case "MI":
                    case "KY":
                    case "VA":
                      this.disableStickyAtcByRegionCode(data.region_code);
                      break;
                    default:
                  }
                }
                if (oosStates.includes("no_PA")) {
                  switch (data.region_code) {
                    case "ME":
                    case "NH":
                    case "VT":
                    case "MA":
                    case "RI":
                    case "CT":
                    case "NJ":
                    case "DE":
                    case "MD":
                    case "NY":
                    case "PA":
                      this.disableStickyAtcByRegionCode(data.region_code);
                      break;
                    default:
                  }
                }
                if (oosStates.includes("no_DOTH")) {
                  switch (data.region_code) {
                    case "AL":
                    case "MS":
                    case "SC":
                    case "NC":
                    case "TN":
                    case "FL":
                    case "GA":
                      this.disableStickyAtcByRegionCode(data.region_code);
                      break;
                    default:
                  }
                }
                if (oosStates.includes("no_US")) {
                  this.disableStickyAtcByRegionCode(data.region_code);
                }
              } else if (data.country_code === "CA") {
                if (oosStates.includes("no_CAN")) {
                  this.disableStickyAtcByRegionCode(data.region_code);
                }
              } else if (data.country_code === "GB") {
                if (oosStates.includes("no_UK")) {
                  this.disableStickyAtcByRegionCode(data.region_code);
                }
              }
            } else {
              // this.disableStickyAtcByRegionCode(data.region_code);
            }
          } catch (e) {
            console.error(e);
          }
        }
      };

      returnFormContents(stickyHeight = 0) {
        this.mainFormContainer.style.height = "auto";
        this.style.height = `${stickyHeight}px`;

        this.removeChild(this.copyOfMainProdForm);
      }
    }
  );
}
